import { FC } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import { GOOGLE_PRIVACY_POLICY, GOOGLE_TERMS_POLICY } from 'src/common/constants';
import Typography from 'src/common/components/Typography';
import UniversalLink from 'src/common/components/UniversalLink';

const GrecaptchaCompliance: FC = () => {
  const [t] = useTranslation('common');
  return (
    <Typography
      type="p"
      size="body-m"
    >
      <Trans
        t={t}
        i18nKey="grecaptcha-compliance"
        components={[
          <UniversalLink href={GOOGLE_PRIVACY_POLICY} />,
          <UniversalLink href={GOOGLE_TERMS_POLICY} />,
        ]}
      />
    </Typography>
  );
};

export default GrecaptchaCompliance;
